import { render } from "./VehiclesView.vue?vue&type=template&id=2395ae34&scoped=true"
import script from "./VehiclesView.vue?vue&type=script&lang=js"
export * from "./VehiclesView.vue?vue&type=script&lang=js"

import "./VehiclesView.vue?vue&type=style&index=0&id=2395ae34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2395ae34"]])

export default __exports__